import { render, staticRenderFns } from "./FactionButtonBar.vue?vue&type=template&id=5a2a2bb9&scoped=true&"
import script from "./FactionButtonBar.vue?vue&type=script&lang=js&"
export * from "./FactionButtonBar.vue?vue&type=script&lang=js&"
import style0 from "./FactionButtonBar.vue?vue&type=style&index=0&id=5a2a2bb9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2a2bb9",
  null
  
)

export default component.exports